"use client";

import ProductHeroBase from "@/components/sections/products/shared/hero-base";
import { residentialStats } from "../data";
import { STATS } from "@/lib/constants";

export default function ResidentialPricingHero() {
  return (
    <ProductHeroBase
      headingId="residential-pricing-hero-heading"
      eyebrow="Residential Proxies — Pricing"
      headingLine1="The only residential proxies"
      headingLine2="you'll ever need."
      description={`${STATS.ips} real residential IPs across ${STATS.countries} countries. One simple plan — pay per GB. No contracts, no hidden fees.`}
      trustBadges={["KYC required", "30-day money-back guarantee"]}
      stats={residentialStats}
      scrollIndicator={{ label: "See plans", href: "#pricing-plans" }}
    />
  );
}
